import fetcherApi from '../components/FetcherApi.jsx';
import urlTools from "../tools/urlTools.jsx";

export default {
  getEmailStructureError(email) {
		return !this.IsEmailStructureValid(email)
			? "account_found_but_no_email_page_in_login_empty_email_field_error"
			: null;
  },
  IsEmailStructureValid: email => /^[^.,@\s][^@\s]*@[^@\s]+\.[^@\s]*[^.,@\s-]$/.test(email ?? "")
};

let fetch = async function (action, apiCall, argument, target) {
  const url = urlTools.constructRoute(apiCall + action + argument + target);
  const result = (await fetcherApi.get(url)).response;
  let errorText = '';

  if (result.status !== 200) {
    errorText = result.error;
  }

  return {
    ['errorStandardOrRateLimit']: errorText,
    ['successCall']: !(!!errorText),
    ['data']: !!errorText ? "" : result.data
  };
};
